// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable declaration-property-value-disallowed-list -- DS */
:root {
    /* Container */
    --ds-toggle-container-outline-color: var(--ds-color-focus-outline);
    --ds-toggle-container-outline-offset: var(--ds-05x);
    --ds-toggle-font-color: var(--ds-color-grey-10);
    --ds-toggle-disabled-font-color: var(--ds-color-grey-30);
    /* Toggle ON */
    --ds-toggle-on-bg-color: var(--ds-color-positive);
    --ds-toggle-on-border-color: transparent;
    /* Toggle ON_DISABLED */
    --ds-toggle-on-disabled-bg-color: var(--ds-color-grey-50);
    --ds-toggle-on-disabled-border-color: transparent;
    /* Toggle OFF */
    --ds-toggle-off-bg-color: var(--ds-color-grey-60);
    --ds-toggle-off-border-color: var(--ds-color-grey-40);
    /* Toggle OFF_DISABLED */
    --ds-toggle-off-disabled-bg-color: var(--ds-color-grey-90);
    --ds-toggle-off-disabled-border-color: var(--ds-color-grey-50);
    /* Toggle In Progress */
    --ds-toggle-in-progress-bg-color: var(--ds-color-grey-70);
    --ds-toggle-in-progress-border-color: transparent;
    /* Circle - Toggle ON */
    --ds-toggle-on-circle-bg-color: var(--ds-color-grey-10);
    --ds-toggle-on-shadow-color: rgb(
        var(--ds-color-grey-indigo-40-rgb) / var(--ds-alpha-40)
    );
    /* Circle - Toggle OFF */
    --ds-toggle-off-circle-bg-color: var(--ds-color-grey-20);
    /* Circle - Toggle ON_DISABLED */
    --ds-toggle-on-disabled-circle-bg-color: var(--ds-color-grey-30);
    /* Circle - Toggle OFF_DISABLED */
    --ds-toggle-off-disabled-circle-bg-color: var(--ds-color-grey-30);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
